const state = {
    now: '00:00',
    interval: null,
    par_impar: true
}

// getters
const getters = {
    today (state) {
        return startOfDay(state.now)
    }
}

// mutations
const mutations = {
    updateTime (state) {
        localStorage.usr_time_count = parseInt(localStorage.usr_time_count?localStorage.usr_time_count:0) + 1 //esto tengo que guardarlo de rato en rato en el servidor para cuandao cierren sesión, no?, mmm de momento no

        var hours = Math.floor( localStorage.usr_time_count / 3600 )
        var minutes = Math.floor( (localStorage.usr_time_count - (hours * 3600)) / 60 )

        hours = hours < 10 ? '0' + hours : hours;
        minutes = minutes < 10 ? '0' + minutes : minutes;

        if (state.par_impar) {            
            state.now = hours + ' ' + minutes
        } else {
            state.now = hours + ':' + minutes
        }

        state.par_impar = !state.par_impar
    },
    stopTime (state) {

        localStorage.usr_time_count = parseInt(localStorage.usr_time_count?localStorage.usr_time_count:0) + 1 //esto tengo que guardarlo de rato en rato en el servidor para cuandao cierren sesión, no?, mmm de momento no

        var hours = Math.floor( localStorage.usr_time_count / 3600 )
        var minutes = Math.floor( (localStorage.usr_time_count - (hours * 3600)) / 60 )

        hours = hours < 10 ? '0' + hours : hours;
        minutes = minutes < 10 ? '0' + minutes : minutes;

        state.now = hours + ':' + minutes

        localStorage.usr_time_count_inprocess = 0
    },
    resetTime (state) {
        localStorage.usr_time_count_inprocess = 0
        localStorage.usr_time_count = 0
        state.now = '00:00'
    }
};

// actions
const actions = {
    start ({ commit }) {
        state.interval = setInterval(() => {
          localStorage.usr_time_count_inprocess = 1
          commit('updateTime')
        }, 1000)
    },
    stop ({ commit }) {
        commit('stopTime')
        clearInterval(state.interval);
    },
    reset ({ commit }) {
        commit('resetTime')
        clearInterval(state.interval);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}